export default __webpack_public_path__ + "static/media/5_magic 1.777563ce.png";